import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactSortable } from 'react-sortablejs';
import SidebarLayout from 'components/Layout/Layout';
import { API_URL } from 'env';
import { Modal, Select, Collapse, Card, Row, Col, Input, Button, Switch } from 'antd';
import TinyMce from 'components/GbCpn/TinyMce';
import ImageUpload from 'components/GbCpn/ImageUpload';
import { FileAddOutlined, DeleteOutlined, EditOutlined, DragOutlined, SaveOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import './AddProduct.scss';

const AddProduct: React.FC = () => {
  const navigate = useNavigate();
  const [bannerImageBase64, setBannerImageBase64] = useState('');
  const { Option } = Select;

  const [locale, setLocale] = useState<string>('en')

  const [form, setForm] = useState({
    title: {
      en: '',
      vi: '',
    },
    description: {
      en: '',
      vi: '',
    },
  });

  const [contentEn, setContentEn] = useState([] as any)
  const [contentVi, setContentVi] = useState([] as any)
  const [loading, setLoading] = useState(false);

  const { Panel } = Collapse;

  const [modalContentEn, setModalContentEn] = useState({
    title: '',
    show: false,
    data: { id: null, title: '', content: '', image: '', position: 'Left', hasButton: false }
  } as any);

  const [modalContentVi, setModalContentVi] = useState({
    title: '',
    show: false,
    data: { id: null, title: '', content: '', image: '', position: 'Left', hasButton: false }
  } as any);

  const removeContentEn = (id: string) => {
    setContentEn(contentEn.filter((desc: any) => desc.id !== id));
  };
  const removeContentVi = (id: string) => {
    setContentVi(contentVi.filter((desc: any) => desc.id !== id));
  };

  const handleSave = async () => {
    if (locale === 'en') {
      if (!form.title.en.trim()) {
        Modal.warning({ title: 'Thiếu thông tin', content: 'Vui lòng nhập tiêu đề' });
        return;
      }

      try {
        setLoading(true);
        const payload = {
          ...form,
          description: {
            en: contentEn,
            vi: contentVi
          },
          introduction: {
            vi: [{ description: form.description.vi }],
            en: [{ description: form.description.en }],
          },
          banner_image: bannerImageBase64,
        };

        const response = await fetch(`${API_URL}api/v1/be/recommendations`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

        const json = await response.json();

        if (json.status) {
          Modal.success({
            title: 'Success',
            content: 'Operation completed successfully',
            onOk: () => navigate('/recomendation'),
          });
        } else {
          Modal.error({
            title: 'Error',
            content: json.error[Object.keys(json.error)[0]] || 'Unknown error',
          });
        }
      } catch (error: any) {
        Modal.error({
          title: 'Error',
          content: error.message,
        });
      } finally {
        setLoading(false);
      }
    } else if (locale === 'vi') {
      if (!form.title.vi.trim()) {
        Modal.warning({ title: 'Thiếu thông tin', content: 'Vui lòng nhập tiêu đề' });
        return;
      }

      try {
        setLoading(true);
        const payload = {
          ...form,
          description: {
            en: contentEn,
            vi: contentVi
          },
          introduction: {
            vi: form.description.vi,
            en: form.description.en,
          },
          banner_image: bannerImageBase64,
        };

        const response = await fetch(`${API_URL}api/v1/be/recommendations`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

        const json = await response.json();

        if (json.status) {
          Modal.success({
            title: 'Success',
            content: 'Operation completed successfully',
            onOk: () => navigate('/recomendation'),
          });
        } else {
          Modal.error({
            title: 'Error',
            content: json.error[Object.keys(json.error)[0]] || 'Unknown error',
          });
        }
      } catch (error: any) {
        Modal.error({
          title: 'Error',
          content: error.message,
        });
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <SidebarLayout title={<h4 className="text-2xl font-bold !m-0 py-4"></h4>}>
      <div className='head-form-box mb-4'>
        <div className='box-left'>
          <ArrowLeftOutlined
            onClick={() => navigate('/recomendation')}
          />
          <div className='title'>Add New Recommendation</div>
        </div>
        <Button loading={loading} onClick={handleSave} type="primary" icon={<SaveOutlined />} size="large">
          Add new
        </Button>
      </div>
      <Row gutter={[16, 16]} className='AddProduct'>
        <Col span={24} lg={18}>
          <Card>
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <div>
                  <label className="block font-semibold mb-1" style={{ color: '#5e5873' }}>
                    Title
                  </label>
                  <Input
                    type="text"
                    value={locale === 'en' ? form.title.en : form.title.vi}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        title: {
                          ...form.title,
                          [locale]: e.target.value,
                        },
                      })
                    }
                  />
                </div>
              </Col>

              <Col span={24}>
                <div>
                  <label className="block font-semibold mb-1" style={{ color: '#5e5873' }}>
                    Description
                  </label>
                  <TinyMce
                    defaultValue={locale === 'en' ? form.description.en : form.description.vi}
                    onChange={(value) =>
                      setForm({
                        ...form,
                        description: {
                          ...form.description,
                          [locale]: value,
                        },
                      })
                    }
                  />
                </div>
              </Col>
            </Row>
          </Card>

          <div className='mt-4'></div>

          {locale === 'en' && <Card title="List content">
            <div className='ctrbox'>
              <div className='box-left'>
                <Button onClick={() => setModalContentEn({ ...modalContentEn, show: true, data: { id: null, title: '', content: 'reset', image: 'reset', position: 'Left', hasButton: false } })} icon={<FileAddOutlined />}>Add content</Button>
              </div>
            </div>

            <div className='list-content-product'>
              <ReactSortable
                list={contentEn}
                setList={setContentEn}
                animation={150}
                className="sortable-list"
                handle=".drag-handle"
              >
                {contentEn.map((desc: any) => (
                  <Collapse key={desc.id} className="mb-2" defaultActiveKey={['1']}>
                    <Panel
                      header={
                        <div className="flex items-center justify-between">
                          <span>{desc.title || 'New Content'}</span>
                          <div className='box-right-cp'>
                            <div className='ctr del-mod' onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              removeContentEn(desc.id)
                            }}>
                              <DeleteOutlined />
                            </div>
                            <div className='ctr edit-mod' onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              setContentEn({ ...modalContentEn, show: true, data: { ...desc } })
                            }}>
                              <EditOutlined />
                            </div>
                            <div className='ctr drag-handle'>
                              <DragOutlined />
                            </div>
                          </div>
                        </div>
                      }
                      key={desc.id}
                    >
                      <div className='content-des'>
                        <div className={`pos-content ${desc.position || 'Left'}`}>
                          <div className='stt-image'>
                            <img src={desc.image} alt="" />
                          </div>
                          <div className='true-content'>
                            <div dangerouslySetInnerHTML={{ __html: desc.content }} />
                          </div>
                        </div>

                      </div>
                    </Panel>
                  </Collapse>
                ))}
              </ReactSortable>
            </div>

            {/* <Modal
              title={modalContent.data.id ? 'Edit Content' : 'Add Content'}
              closable={{ 'aria-label': 'Custom Close Button' }}
              open={modalContent.show}
              width={1000}
              okText={modalContent.data.id ? 'Update' : 'Add'}
              onOk={() => {
                if (modalContent.data.id) {
                  const updatedDescriptions = descriptions.map((desc: any) =>
                    desc.id === modalContent.data.id ? modalContent.data : desc
                  );
                  setDescriptions(updatedDescriptions);
                } else {
                  descriptions.push({
                    id: modalContent.data.id || Date.now().toString(),
                    title: modalContent.data.title,
                    content: modalContent.data.content,
                    image: modalContent.data.image,
                    position: modalContent.data.position,
                    hasButton: modalContent.data.hasButton || false,
                  });
                  setDescriptions([...descriptions]);
                }
                setModalContent({ ...modalContent, show: false });
              }}
              onCancel={() => setModalContent({ ...modalContent, show: false })}
            >
              <Row gutter={[16, 16]} className='modal-content-product'>
                <Col span={12}>
                  <label className="block font-semibold mb-1" style={{ color: '#5e5873' }}>
                    Title
                  </label>
                  <Input
                    placeholder="Title"
                    value={modalContent.data.title}
                    onChange={(e) => setModalContent({
                      ...modalContent,
                      data: { ...modalContent.data, title: e.target.value }
                    })}
                  />
                </Col>
                <Col span={6}>
                  <label className="block font-semibold mb-1" style={{ color: '#5e5873' }}>
                    Position image
                  </label>
                  <Select
                    placeholder="Position"
                    value={modalContent.data.position}
                    onChange={(value) => setModalContent({
                      ...modalContent,
                      data: { ...modalContent.data, position: value }
                    })}
                    style={{ width: '100%' }}
                  >
                    <Option value="Left">Left</Option>
                    <Option value="Right">Right</Option>
                    <Option value="Bottom">Bottom</Option>
                    <Option value="Top">Top</Option>
                    <Option value="NoImage">No image</Option>
                  </Select>
                </Col>
                <Col span={6}>
                  <label className="block font-semibold mb-1" style={{ color: '#5e5873' }}>
                    Has Button
                  </label>
                  <Switch checked={modalContent.data.hasButton} onChange={(value) => setModalContent({ ...modalContent, data: { ...modalContent.data, hasButton: value } })} />
                </Col>
                <Col span={24}>
                  <div className={`pos-content ${modalContent.data.position || 'Left'}`}>
                    <div className='stt-image'>
                      <label className="block font-semibold mb-1" style={{ color: '#5e5873' }}>
                        Image
                      </label>
                      <ImageUpload
                        raito={'380/267'}
                        defaultValue={modalContent.data.image}
                        onChange={(file) => {
                          if (file) {
                            const reader = new FileReader();
                            reader.onloadend = () => setModalContent({
                              ...modalContent,
                              data: { ...modalContent.data, image: reader.result as string }
                            });
                            reader.readAsDataURL(file);
                          } else {
                            setBannerImageBase64('');
                          }
                        }}
                      />
                    </div>
                    <div className='true-content'>
                      <label className="block font-semibold mb-1" style={{ color: '#5e5873' }}>
                        Description
                      </label>
                      <TinyMce
                        defaultValue={modalContent.data.content}
                        onChange={(content: any) => setModalContent({
                          ...modalContent,
                          data: { ...modalContent.data, content: content }
                        })}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </Modal> */}

            <Modal
              title={modalContentEn.data.id ? 'Edit Content' : 'Add Content'}
              closable={{ 'aria-label': 'Custom Close Button' }}
              open={modalContentEn.show}
              width={1000}
              okText={modalContentEn.data.id ? 'Update' : 'Add'}
              onOk={() => {
                if (modalContentEn.data.id) {
                  const updatedDescriptions = contentEn.map((desc: any) =>
                    desc.id === modalContentEn.data.id ? modalContentEn.data : desc
                  );
                  setContentEn(updatedDescriptions);
                } else {
                  contentEn.push({
                    id: modalContentEn.data.id || Date.now().toString(),
                    title: modalContentEn.data.title,
                    content: modalContentEn.data.content,
                    image: modalContentEn.data.image,
                    position: modalContentEn.data.position,
                    hasButton: modalContentEn.data.hasButton || false,
                  });
                  setContentEn([...contentEn]);
                }
                setModalContentEn({ ...modalContentEn, show: false });
              }}
              onCancel={() => setModalContentEn({ ...modalContentEn, show: false })}
            >
              <Row gutter={[16, 16]} className='modal-content-product'>
                <Col span={12}>
                  <label className="block font-semibold mb-1" style={{ color: '#5e5873' }}>
                    Title
                  </label>
                  <Input
                    placeholder="Title"
                    value={modalContentEn.data.title}
                    onChange={(e) => setModalContentEn({
                      ...modalContentEn,
                      data: { ...modalContentEn.data, title: e.target.value }
                    })}
                  />
                </Col>
                <Col span={6}>
                  <label className="block font-semibold mb-1" style={{ color: '#5e5873' }}>
                    Position image
                  </label>
                  <Select
                    placeholder="Position"
                    value={modalContentEn.data.position}
                    onChange={(value) => setModalContentEn({
                      ...modalContentEn,
                      data: { ...modalContentEn.data, position: value }
                    })}
                    style={{ width: '100%' }}
                  >
                    <Option value="Left">Left</Option>
                    <Option value="Right">Right</Option>
                    <Option value="Bottom">Bottom</Option>
                    <Option value="Top">Top</Option>
                    <Option value="NoImage">No image</Option>
                  </Select>
                </Col>
                <Col span={6}>
                  <label className="block font-semibold mb-1" style={{ color: '#5e5873' }}>
                    Has Button
                  </label>
                  <Switch checked={modalContentEn.data.hasButton} onChange={(value) => setModalContentEn({ ...modalContentEn, data: { ...modalContentEn.data, hasButton: value } })} />
                </Col>
                <Col span={24}>
                  <div className={`pos-content ${modalContentEn.data.position || 'Left'}`}>
                    <div className='stt-image'>
                      <label className="block font-semibold mb-1" style={{ color: '#5e5873' }}>
                        Image
                      </label>
                      <ImageUpload
                        raito={'380/267'}
                        defaultValue={modalContentEn.data.image}
                        onChange={(file) => {
                          if (file) {
                            const reader = new FileReader();
                            reader.onloadend = () => setModalContentEn({
                              ...modalContentEn,
                              data: { ...modalContentEn.data, image: reader.result as string }
                            });
                            reader.readAsDataURL(file);
                          } else {
                            setBannerImageBase64('');
                          }
                        }}
                      />
                    </div>
                    <div className='true-content'>
                      <label className="block font-semibold mb-1" style={{ color: '#5e5873' }}>
                        Description
                      </label>
                      <TinyMce
                        defaultValue={modalContentEn.data.content}
                        onChange={(content: any) => setModalContentEn({
                          ...modalContentEn,
                          data: { ...modalContentEn.data, content: content }
                        })}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </Modal>
          </Card>}

          {locale === 'vi' && <Card title="List content">
            <div className='ctrbox'>
              <div className='box-left'>
                <Button onClick={() => setModalContentVi({ ...modalContentVi, show: true, data: { id: null, title: '', content: 'reset', image: 'reset', position: 'Left', hasButton: false } })} icon={<FileAddOutlined />}>Add content</Button>
              </div>
            </div>

            <div className='list-content-product'>
              <ReactSortable
                list={contentVi}
                setList={setContentVi}
                animation={150}
                className="sortable-list"
                handle=".drag-handle"
              >
                {contentVi.map((desc: any) => (
                  <Collapse key={desc.id} className="mb-2" defaultActiveKey={['1']}>
                    <Panel
                      header={
                        <div className="flex items-center justify-between">
                          <span>{desc.title || 'New Content'}</span>
                          <div className='box-right-cp'>
                            <div className='ctr del-mod' onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              removeContentVi(desc.id)
                            }}>
                              <DeleteOutlined />
                            </div>
                            <div className='ctr edit-mod' onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              setContentVi({ ...modalContentVi, show: true, data: { ...desc } })
                            }}>
                              <EditOutlined />
                            </div>
                            <div className='ctr drag-handle'>
                              <DragOutlined />
                            </div>
                          </div>
                        </div>
                      }
                      key={desc.id}
                    >
                      <div className='content-des'>
                        <div className={`pos-content ${desc.position || 'Left'}`}>
                          <div className='stt-image'>
                            <img src={desc.image} alt="" />
                          </div>
                          <div className='true-content'>
                            <div dangerouslySetInnerHTML={{ __html: desc.content }} />
                          </div>
                        </div>

                      </div>
                    </Panel>
                  </Collapse>
                ))}
              </ReactSortable>
            </div>

            <Modal
              title={modalContentVi.data.id ? 'Edit Content' : 'Add Content'}
              closable={{ 'aria-label': 'Custom Close Button' }}
              open={modalContentVi.show}
              width={1000}
              okText={modalContentVi.data.id ? 'Update' : 'Add'}
              onOk={() => {
                if (modalContentVi.data.id) {
                  const updatedDescriptions = contentVi.map((desc: any) =>
                    desc.id === modalContentVi.data.id ? modalContentVi.data : desc
                  );
                  setContentVi(updatedDescriptions);
                } else {
                  contentVi.push({
                    id: modalContentVi.data.id || Date.now().toString(),
                    title: modalContentVi.data.title,
                    content: modalContentVi.data.content,
                    image: modalContentVi.data.image,
                    position: modalContentVi.data.position,
                    hasButton: modalContentVi.data.hasButton || false,
                  });
                  setContentVi([...contentVi]);
                }
                setModalContentVi({ ...modalContentVi, show: false });
              }}
              onCancel={() => setModalContentVi({ ...modalContentVi, show: false })}
            >
              <Row gutter={[16, 16]} className='modal-content-product'>
                <Col span={12}>
                  <label className="block font-semibold mb-1" style={{ color: '#5e5873' }}>
                    Title
                  </label>
                  <Input
                    placeholder="Title"
                    value={modalContentVi.data.title}
                    onChange={(e) => setModalContentVi({
                      ...modalContentVi,
                      data: { ...modalContentVi.data, title: e.target.value }
                    })}
                  />
                </Col>
                <Col span={6}>
                  <label className="block font-semibold mb-1" style={{ color: '#5e5873' }}>
                    Position image
                  </label>
                  <Select
                    placeholder="Position"
                    value={modalContentVi.data.position}
                    onChange={(value) => setModalContentVi({
                      ...modalContentVi,
                      data: { ...modalContentVi.data, position: value }
                    })}
                    style={{ width: '100%' }}
                  >
                    <Option value="Left">Left</Option>
                    <Option value="Right">Right</Option>
                    <Option value="Bottom">Bottom</Option>
                    <Option value="Top">Top</Option>
                    <Option value="NoImage">No image</Option>
                  </Select>
                </Col>
                <Col span={6}>
                  <label className="block font-semibold mb-1" style={{ color: '#5e5873' }}>
                    Has Button
                  </label>
                  <Switch checked={modalContentVi.data.hasButton} onChange={(value) => setModalContentVi({ ...modalContentVi, data: { ...modalContentVi.data, hasButton: value } })} />
                </Col>
                <Col span={24}>
                  <div className={`pos-content ${modalContentVi.data.position || 'Left'}`}>
                    <div className='stt-image'>
                      <label className="block font-semibold mb-1" style={{ color: '#5e5873' }}>
                        Image
                      </label>
                      <ImageUpload
                        raito={'380/267'}
                        defaultValue={modalContentVi.data.image}
                        onChange={(file) => {
                          if (file) {
                            const reader = new FileReader();
                            reader.onloadend = () => setModalContentVi({
                              ...modalContentVi,
                              data: { ...modalContentVi.data, image: reader.result as string }
                            });
                            reader.readAsDataURL(file);
                          } else {
                            setBannerImageBase64('');
                          }
                        }}
                      />
                    </div>
                    <div className='true-content'>
                      <label className="block font-semibold mb-1" style={{ color: '#5e5873' }}>
                        Description
                      </label>
                      <TinyMce
                        defaultValue={modalContentVi.data.content}
                        onChange={(content: any) => setModalContentVi({
                          ...modalContentVi,
                          data: { ...modalContentVi.data, content: content }
                        })}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </Modal>
          </Card>}
        </Col>
        <Col span={24} lg={6}>
          <Card>
            <div className="mb-4">
              <label className="block font-semibold mb-1" style={{ color: '#5e5873' }}>
                Locale
              </label>
              <Select
                value={locale}
                onChange={(e) => setLocale(e)}
                style={{ width: '100%' }}
              >
                <option value="vi">Vietnam</option>
                <option value="en">English</option>
              </Select>
            </div>
          </Card>
        </Col>
      </Row>
      <div className='ctrbox-foot mt-4'>
        <Button loading={loading} onClick={handleSave} type="primary" icon={<SaveOutlined />} size="large">
          Add new
        </Button>
      </div>
    </SidebarLayout>
  );
};

export default AddProduct;